import { network } from 'services/network';

export const runSchedulingSimulation = ({ metaDataId, simulationDate }) => {
    return network
        .post('api/bo/runSchedulingSimulation', { metaDataId, simulationDate })
        .then((response) => response.data);
};
